// extracted by mini-css-extract-plugin
export default {"h1":"H1_h1__Hcz09","noMargin":"H1_noMargin__QuFDj","noPadding":"H1_noPadding__ivdou","noRightMargin":"H1_noRightMargin__dWn66"};